import React from "react";
import classes from "./BankEmployeeList.module.css";
import { Col, Row } from "antd";
import { CheckCircleTwoTone } from "@ant-design/icons";

export interface BankEmployee {
  id: number;
  name: string;
  patronymic: string;
  surname: string;
}

interface BankEmployeeListProps {
  bankEmployees: readonly BankEmployee[];
  selectedBankEmployee: BankEmployee | null;
  setSelectedBankEmployee: (underwriter: BankEmployee) => void;
}

export const BankEmployeeList = ({
  bankEmployees,
  selectedBankEmployee,
  setSelectedBankEmployee,
}: BankEmployeeListProps) => {
  const checkIsSelected = (bankEmployee: BankEmployee) => {
    return selectedBankEmployee?.id === bankEmployee.id;
  };

  return (
    <Col className={classes.list}>
      {bankEmployees.map((bankEmployee) => {
        const { id, name, surname, patronymic } = bankEmployee;
        return (
          <Row
            key={id}
            className={`${classes.listItem} ${
              checkIsSelected(bankEmployee) && classes.listItemSelected
            }`}
            onClick={() => setSelectedBankEmployee(bankEmployee)}
          >
            <span>{`${surname} ${name} ${patronymic}`}</span>

            {checkIsSelected(bankEmployee) && (
              <CheckCircleTwoTone twoToneColor="#52c41a" />
            )}
          </Row>
        );
      })}
    </Col>
  );
};
